export default {
    pageTitle: 'Dashboard',
    noAvailableType: 'No available license type for this platform',
    name: 'Dashboard',
};
